import { Spotify_axios_adapter } from "./Spotify_axios_adapter";
import Spotify_constant from './Spotify_constant';

const Spotify_api_service = {

    spotifyCategories: async () => {
        try {
            const response = await Spotify_axios_adapter.get(`${Spotify_constant.ENDPOINT_SPOTIFY.CATEGORIES}`,
                {
                    baseURL: Spotify_constant.SPOTIFY_BASE_URL_2,
                }
            );
            return response.data;
        } catch (error) {
            return error;
        }
    },

    spotifySpecificCategoriesInfo: async (category_id) => {
        try {
            const response = await Spotify_axios_adapter.get(`${Spotify_constant.ENDPOINT_SPOTIFY.CATEGORIES}/${category_id}`,
                {
                    baseURL: Spotify_constant.SPOTIFY_BASE_URL_2,
                }
            );
            return response.data;
        } catch (error) {
            return error;
        }
    },

    spotifySearchSongByTitle: async (query,type) => {
        try {
            /**
             * type = album/artist/playlist/track/show/episode/audiobook
             */
            const response = await Spotify_axios_adapter.get(`${Spotify_constant.ENDPOINT_SPOTIFY.SEARCH}`,
                {
                    baseURL: Spotify_constant.SPOTIFY_BASE_URL_2,
                    params: { q:query, type:type, }
                }
            );
            return response.data;
        } catch (error) {
            return error;
        }
    },

    spotifyGetTrackInfo: async (track_id) => {
        try {
            const response = await Spotify_axios_adapter.get(`${Spotify_constant.ENDPOINT_SPOTIFY.TRACKS}/${track_id}`,
                {
                    baseURL: Spotify_constant.SPOTIFY_BASE_URL_2,
                }
            );
            return response.data;
        } catch (error) {
            return error;
        }
    },

    spotifyGetArtistInfo: async (artist_id) => {
        try {
            const response = await Spotify_axios_adapter.get(`${Spotify_constant.ENDPOINT_SPOTIFY.ARTISTS}/${artist_id}`,
                {
                    baseURL: Spotify_constant.SPOTIFY_BASE_URL_2,
                }
            );
            return response.data;
        } catch (error) {
            return error;
        }
    },

    spotifyGetArtistAlbums: async (artist_id,limit = 20, offset = 0) => {
        try {
            const response = await Spotify_axios_adapter.get(`${Spotify_constant.ENDPOINT_SPOTIFY.ARTISTS}/${artist_id}/albums`,
                {
                    baseURL: Spotify_constant.SPOTIFY_BASE_URL_2,
                    params: {
                        limit,
                        offset,
                    },
                }
            );
            return response.data;
        } catch (error) {
            return error;
        }
    },

    spotifyGetArtistTopTracks: async (artist_id) => {
        try {
            const response = await Spotify_axios_adapter.get(`${Spotify_constant.ENDPOINT_SPOTIFY.ARTISTS}/${artist_id}/top-tracks`,
                {
                    baseURL: Spotify_constant.SPOTIFY_BASE_URL_2,
                }
            );
            return response.data;
        } catch (error) {
            return error;
        }
    },

    spotifyGetAlbumTracks: async (album_id) => {
        try {
            const response = await Spotify_axios_adapter.get(`${Spotify_constant.ENDPOINT_SPOTIFY.ALBUMS}/${album_id}/tracks`,
                {
                    baseURL: Spotify_constant.SPOTIFY_BASE_URL_2,
                }
            );
            return response.data;
        } catch (error) {
            return error;
        }
    },

    spotifyNewRelease: async () => {
        try {
            const response = await Spotify_axios_adapter.get(`${Spotify_constant.ENDPOINT_SPOTIFY.NEW_RELEASE}`,
                {
                    baseURL: Spotify_constant.SPOTIFY_BASE_URL_2,
                }
            );
            return response.data;
        } catch (error) {
            return error;
        }
    }
}

export default Spotify_api_service;